<template>
	<Main>
		<v-container>
			 <div class="text--primary">
                <v-row>                 
                  <v-col md="3" sm="6">
                    <v-text-field
                      color="red darken-1"
                      v-model="invoice"
                      append-icon="mdi-magnify"
                      label="Search Invoice"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
				  <v-col md="6" sm="6">
                    <v-btn color="warning" @click="searchInvoice()">Search</v-btn>
                  </v-col>
                </v-row>
              </div>
			<v-row>
				<v-col cols="12">
					<v-card shaped class="pa-5">
						<strong>AAM - ADJUST INCENTIVE</strong>
						<!-- <v-file-input style="width: 25%" label="Upload File"></v-file-input>
						<v-btn color="warning">Submit</v-btn> -->
						<div class="d-flex flex-column mt-6">
							<!-- HEADER -->
							<div
								class="d-flex justify-space-between mb-2"
								style="width: 100%; font-size: 12px;"
							>
								<div class="mx-1" style="width: 10.3%;">INVOICE NO</div>
								<div class="mx-1" style="width: 10.3%;">CUSTOMER NAME</div>
								<div class="mx-1" style="width: 10.3%;">INVOICE DATE</div>
								<div class="mx-1" style="width: 10.3%;">ITEM DESC</div>
								<div class="mx-1" style="width: 10.3%;">QTY</div>
								<div class="mx-1" style="width: 10.3%;">AMOUNT</div>
								<div class="mx-1" style="width: 10.3%;">POSITION FROM</div>
								<div class="mx-1" style="width: 10.3%;">POSITION TO</div>
								<div class="mx-1" style="width: 10.3%;">REASON</div>
								<div class="mx-1" style="width: 5%;">DEL</div>
							</div>
							<!-- ROW -->
							<div v-for="(item, index) in arrRow" :key="index" class="d-flex">
								<v-text-field
									v-model="arrRow[index].invoice"
									class="mx-1"
									style="width: 10.3%;"
									solo
									readonly
								></v-text-field>
								<v-text-field
									v-model="arrRow[index].customerName"
									class="mx-1"
									style="width: 10.3%;"
									solo
									readonly
								></v-text-field>
								<v-text-field
									v-model="arrRow[index].invoiceDate"
									class="mx-1"
									style="width: 10.3%;"
									solo
									readonly
								></v-text-field>
								<v-autocomplete
									v-model="arrRow[index].productID"
									:items="arrRow[index].arrItem"
									item-text="ITEM_DESCRIPTION"
									item-value="INVENTORY_ITEM_ID"
									class="mx-1"
									style="width: 10.3%;"
									@change="onItemSelect($event, index)"
									solo
								></v-autocomplete>
								<v-text-field
									v-model="arrRow[index].quantity"
									class="mx-1"
									style="width: 10.3%;"
									solo
									readonly
								></v-text-field>
								<v-text-field
									v-model="arrRow[index].amount"
									class="mx-1"
									style="width: 10.3%;"
									solo
									readonly
								></v-text-field>
								<v-autocomplete
									v-model="arrRow[index].positionFrom"
									:items="arrRow[index].arrPositionFrom"
									item-text="POSITION_CODE"
									item-value="POSITION_CODE"
									class="mx-1"
									style="width: 10.3%;"
									@change="onChangePosFrom($event, index)"
									solo
								></v-autocomplete>
								<v-autocomplete
									v-model="arrRow[index].positionTo"
									:items="salesList"
									item-text="POSITION_CODE"
									item-value="POSITION_CODE"
									class="mx-1"
									style="width: 10.3%;"
									@change="onChangePosTo($event, index)"
									solo
								></v-autocomplete>
								<v-autocomplete
									v-model="arrRow[index].reason"
									:items="arrReason"
									item-text="REASON_DESC"
									item-value="REASON_DESC"
									class="mx-1"
									style="width: 10.3%;"
									@change="onChangeReason($event, index)"
									solo
								></v-autocomplete>
								<!-- <v-text-field
									v-model="arrRow[index].reason"
									class="mx-1"
									style="width: 10.3%;"
									solo
								></v-text-field> -->
								 <template >
									<v-icon style="width: 5%;" small class="mr-2" @click="deleteItem(index)"
										>mdi-delete</v-icon
									>
								</template>
							</div>
							<div class="d-flex justify-center">
								<v-btn @click="addRow" small class="mx-1" color="warning"
									>ADD ROW</v-btn
								>
								<!-- <v-btn @click="deleteRow" small class="mx-1" color="error"
									>DELETE ROW</v-btn
								> -->
							</div>
							<div class="mt-8">
								<v-btn @click="submit" block color="success">S U B M I T</v-btn>
							</div>
						</div>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
		<!-- SNACKBAR -->
		<v-snackbar v-model="isShowSnackbar" top>
			{{ snackbarText }}
		</v-snackbar>
		<!-- LOADING OVERLAY -->
		<v-overlay :value="isLoading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</Main>
</template>

<script>
import Main from '@/Main.vue';
import moment from 'moment';

export default {
	components: {
		Main,
	},
	data() {
		return {
			radio: null,
			arrRow: [],
			arrInvoice:[],
			isShowSnackbar: false,
			snackbarText: '',
			isLoading: false,
			salesList: [],
			arrPositionFrom: [],
			arrItemSelected: [],
			arrReason:[],
			orgID: JSON.parse(localStorage.getItem('userData')).ORG_ID,
			dtValidPeriod: ""
		};
	},
	mounted() {	
		this.populateSalesList();
		this.populateReason();
		this.cekPeriod();
	},
	methods: {
		 cekPeriod() {
			const userData = JSON.parse(localStorage.getItem("userData"));
              this.isLoading = true;
            let data = {
                typeID: 'INCENTIVE',
                orgID :  userData.ORG_ID
            };
            this.$http
                .post("/setting/validPeriod", data, {
					headers: {
						"api-key": this.$apiKey
					}
				})
                .then(res => {
                   this.isLoading = false;
                    const {
                        success,
                        message,
                        data
                    } = res.data;
                    this.dtValidPeriod = data.length;
                })
                .catch(err => {
                    this.isLoading = false;
                    this.showSnackbar(err.toString());
                });
        },
		addRow() {
			this.arrRow.push({
				customerId: this.arrInvoice[0].SOLD_TO_CUSTOMER_ID,
				customerName: this.arrInvoice[0].CUSTOMER_NAME,
				invoice: this.arrInvoice[0].TRX_NUMBER,
				invoiceDate:  moment(this.arrInvoice[0].TRX_DATE).format("YYYY-MM-DD"),
				productID: '',
				productName: '',
				productDesc: '',
				positionFrom: '',
				positionTo: '',
				quantity: '',
				amount: '',
				reason: '',
				arrItem: this.arrInvoice,
				arrPositionFrom: '',
				userIdUpdate: JSON.parse(localStorage.getItem('userData')).USER_ID
				
			});
		},
		deleteRow() {
			this.arrRow.pop();
		},
		populateReason() {
			this.isLoading = true;
			this.$http
				.post('/adjust-incentive/getSelectReasonAdjustIncentive', null, {
					headers: {
						"api-key": this.$apiKey
					}
				})
				.then((res) => {
					this.isLoading = false;
					const { data } = res.data;
					this.arrReason = data;
					
				})
				.catch((err) => {
					this.isLoading = false;
					this.showSnackbar(err.toString());
				});
		},
		populateSalesList() {
			let data = {
				orgID: this.orgID
			};
			this.isLoading = true;
			this.$http
				.post('/adjust-incentive/getSalesRepStructure',data, {
					headers: {
						"api-key": this.$apiKey
					}
				})
				.then((res) => {
					this.isLoading = false;
					const { data } = res.data;
					this.salesList = data;
					
				})
				.catch((err) => {
					this.isLoading = false;
					this.showSnackbar(err.toString());
				});
		},
		getSelectStructureFrom(productName,custID,index) {
			let data = {
				productName: productName,
				custID: custID
			};
			console.log('data select ', data)
			this.isLoading = true;
			this.$http
				.post('/adjust-incentive/getSelectStructureFrom', data, {
					headers: {
						"api-key": this.$apiKey
					}
				})
				.then((res) => {
					this.isLoading = false;
					const { data } = res.data;
					this.arrPositionFrom = data;
					this.arrRow[index].arrPositionFrom = data;
				})
				.catch((err) => {
					this.isLoading = false;
					this.showSnackbar(err.toString());
				});
		},
		onChangePosFrom(POSITION_CODE, index) {
			this.arrRow[index].positionFrom = POSITION_CODE;
		},
		onChangePosTo(POSITION_CODE, index) {
			this.arrRow[index].positionTo = POSITION_CODE;
		},
		onChangeReason(reason_id, index) {
			this.arrRow[index].reason = reason_id;
		},
		onChangeAmount(amount, index){
			this.arrRow[index].amount = amount;
		},
		deleteItem(index){
			if (confirm(" Apakah anda yakin akang menghapus data ini?")) {
				this.$delete(this.arrRow, index)
			}
		},
		async onItemSelect(INVENTORY_ITEM_ID, index) {
			let invoice = this.invoice.toString();
			let arrRow = this.arrRow;
			let arrItemRow = await arrRow.filter(function(e){
                return e.productID === INVENTORY_ITEM_ID && e.invoice === invoice
            })	
			if(arrItemRow.length>1){
				this.showSnackbar(arrItemRow[0].productDesc + ' already exist.');
				this.arrRow[index].quantity = '';
				this.arrRow[index].amount = '';
				this.arrRow[index].productDesc = '';
				this.arrRow[index].productID = '';
				this.arrRow[index].productName = '';
			}else{	
				let arrItemSelected = await this.arrInvoice.filter(function(e){
					return e.INVENTORY_ITEM_ID === INVENTORY_ITEM_ID
				})		
				this.getSelectStructureFrom(arrItemSelected[0].ITEM_CODE,this.arrRow[index].customerId,index);	
				this.arrRow[index].quantity = arrItemSelected[0].QUANTITY_INVOICED;
				this.arrRow[index].amount = arrItemSelected[0].EXTENDED_AMOUNT;
				this.arrRow[index].productDesc = arrItemSelected[0].ITEM_DESCRIPTION;
				this.arrRow[index].productID = INVENTORY_ITEM_ID;
				this.arrRow[index].productName = arrItemSelected[0].ITEM_CODE;
			}
		},
		searchInvoice() {
			if(this.dtValidPeriod>0){   
				 let data = {
					invoiceNO: this.invoice
				};
				this.isLoading = true;

				this.$http
				.post('/adjust-incentive/getInvoiceByID', data, {
					headers: {
						"api-key": this.$apiKey
					}
				})
				.then((res) => {
						this.isLoading = false;
						let data = res.data.data;
						console.log('data ', data);
						if (res.data.success) {
							this.arrRow.push({
								customerId: data[0].SOLD_TO_CUSTOMER_ID,
								customerName: data[0].CUSTOMER_NAME,
								invoice: data[0].TRX_NUMBER,
								invoiceDate: moment(data[0].TRX_DATE).format("YYYY-MM-DD"),
								productID: '',
								productName: '',
								productDesc: '',
								positionFrom: '',
								positionTo: '',
								quantity: '',
								amount: '',
								reason: '',
								arrItem: data,
								arrPositionFrom: '',
								userIdUpdate: JSON.parse(localStorage.getItem('userData')).USER_ID,
							});
							//console.log('this.arrRow ', this.arrRow);
							//this.arrRow=data;
							this.arrInvoice=data;
							//this.showSnackbar('Success..');
						} else {
							this.showSnackbar('Something is wrong..');
						}
				})
				.catch((err) => {
						this.isLoading = false;
						this.showSnackbar(err.toString());
				});
			}else{
				this.showSnackbar(
                  "Periode sudah ditutup."
                );
			}			
		},
		submit() {
			let arrRowVal = this.arrRow;
			let isEmpty = 0;
			if(arrRowVal.length == 0){
				isEmpty = 1;
			}
            arrRowVal.forEach((val, i) => {              
				let productID = arrRowVal[i].productID;
				let productName = arrRowVal[i].productName;
				let productDesc = arrRowVal[i].productDesc;
				let positionFrom = arrRowVal[i].positionFrom;
				let positionTo = arrRowVal[i].positionTo;
				let quantity = arrRowVal[i].quantity;
				let amount = arrRowVal[i].amount;
				let reason = arrRowVal[i].reason;
				if(productID===''){
					isEmpty = 1;
				}else if(productName===''){
					isEmpty = 1;
				}else if(productDesc===''){
					isEmpty = 1;
				}else if(positionFrom===''){
					isEmpty = 1;
				}else if(positionTo===''){
					isEmpty = 1;
				}else if(quantity===''){
					isEmpty = 1;
				}else if(amount===''){
					isEmpty = 1;
				}else if(reason===''){
					isEmpty = 1;
				}
            });

			if(isEmpty==1){
				this.showSnackbar("Please fill in all data.");
			}else{				
				this.isLoading = true;
				this.$http
				.post('/adjust-incentive/insert', this.arrRow, {
					headers: {
						"api-key": this.$apiKey
					}
				})
				.then((res) => {
					this.isLoading = false;
					const data = res.data;
					const dataFB = res.data.data;
					if (data.success) {
						let strMessage='';
						let isExist = false;
						let dataInvalid=[];
						let arrDuplicate=[];
						dataFB.map(async (obj,i) => {																			
							if(dataFB[i].message[0].RESULT==='System has detect Duplicate Data'){
								arrDuplicate = await this.arrRow.filter(function(e){
									return e.productID == dataFB[i].productID
								})	
								//dataInvalid = dataInvalid.concat(arrDuplicate);
								dataInvalid = arrDuplicate;
								strMessage = "System has detect Duplicate Data"
								isExist=true;
								this.arrRow = dataInvalid;								
								this.showSnackbar(strMessage);
							}else{
								strMessage = "Data saved successfully"
								isExist=false;
							}
						})
						if(!isExist){						
							this.arrRow = [];							
							this.showSnackbar(strMessage);
						}
					} else {
						this.showSnackbar(res.data.data);
					}
				})
				.catch((err) => {
					this.isLoading = false;
					this.showSnackbar(err.toString());
				});
			}			
		},
		showSnackbar(text) {
			this.snackbarText = text;
			this.isShowSnackbar = true;
		},
	},
};
</script>
